// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__c1uuI","placeHolderShimmer":"Report_placeHolderShimmer__GNw0X"};